// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".svg-icon[data-v-41bc67b7]{width:.2rem;height:.2rem;fill:currentColor;stroke:currentColor}", ""]);
// Exports
module.exports = exports;
